<div class="row">
  <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
       [labelInput]="'Processo telematico'"
       [valueInput]="ctxBodyFascicolo.fascicolo.flagProcessoTelematico ? 'Si' : 'No'"></div>
</div>
<ng-template [ngIf]="ctxBodyFascicolo.fascicolo.capofila || ctxBodyFascicolo.fascicolo.riunito">
  <div class="row container_fieldset">
    <div class="col-sm-12">
      <fieldset class="form-group">
        <legend>Riunione dei giudizi</legend>
        <ng-template [ngIf]="ctxBodyFascicolo.fascicolo.capofila">
          <div labelTextInput class="col-sm-4 bloccodati"
               [typeLabel]="'text'" [labelInput]="'Capofila'"
               [valueInput]="ctxBodyFascicolo.fascicolo.capofila ? 'Si' : 'No'"></div>
        </ng-template>
        <ng-template [ngIf]="ctxBodyFascicolo.fascicolo.riunito">
          <div labelTextInput class="col-sm-4 bloccodati"
               [typeLabel]="'text'" [labelInput]="'Riunito'"
               [valueInput]="ctxBodyFascicolo.fascicolo.riunito ? 'Si' : 'No'"></div>
        </ng-template>
        <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
             [labelInput]="'Data riunione'"
             [valueInput]="ctxBodyFascicolo.fascicolo.dataRiunioneGiudizio"></div>
        <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Motivo riunione'"
             [valueInput]="ctxBodyFascicolo.fascicolo.motivoRiunioneGiudizio"></div>
      </fieldset>
    </div>
  </div>
</ng-template>


<div class="row container_fieldset">
  <div class="col-sm-12">
    <fieldset class="form-group">
      <legend>Precetto di riferimento</legend>
      <div labelTextInput class="col-sm-3 bloccodati"
           [typeLabel]="'text'" [labelInput]="'Posizione'"
           [valueInput]="ctxBodyFascicolo.fascicolo.posizioneFascicoloRif"></div>
      <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
           [labelInput]="'N&deg; ruolo/decreto'"
           [valueInput]="ctxBodyFascicolo.fascicolo.numRuoloDecretoRif"></div>
      <div labelTextInput class="col-sm-3 bloccodati"
           [typeLabel]="'date'" [labelInput]="'Data apertura'"
           [valueInput]="ctxBodyFascicolo.fascicolo.dataInizioFascicoloRif"></div>
      <div labelTextInput class="col-sm-3 bloccodati"
           [typeLabel]="'importo'" [labelInput]="'Valore'"
           [valueInput]="ctxBodyFascicolo.fascicolo.valorePrecettoDiRiferimento"></div>
    </fieldset>
  </div>
</div>
<div class="row container_fieldset">
  <div class="col-sm-12">
    <fieldset class="form-group">
      <legend>Pignoramento</legend>
      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'"
           [labelInput]="'Data del pignoramento'"
           [valueInput]="ctxBodyFascicolo.fascicolo.dataPignoramento"></div>
      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'"
           [labelInput]="'Data consegna al creditore'"
           [valueInput]="ctxBodyFascicolo.fascicolo.dataConsegnaAlCreditore"></div>
    </fieldset>
  </div>
</div>

<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>
